$(function(){
  execInView();
	//ページ内リンク
	innerLinkMove();

  $('#js-rioChekiSlider').slick({
    centerMode: true,
    centerPadding: '94px',
    slidesToShow: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000
  });

  $('.js-popupInline').magnificPopup({
    type:'inline',
    midClick: true,
    fixedContentPos: true,
    mainClass: 'mfp-fade'
  });

  $('.js-riochekiPopupInline').magnificPopup({
    type:'inline',
    midClick: true,
    fixedContentPos: true,
    mainClass: 'mfp-fade',
    gallery: { //ギャラリー表示にする
      enabled: true
    }
  });

  qaForm();
});

window.addEventListener('load', () => {
  // ナビゲーション
  bssNav();
  // 背景画像の切り替え
  scrollChangeBg();
  // スクロールでBSSナビゲーションの表示を切り替える
  toggleBssNavOnScroll();
  // アコーディオン
  setUpAccordion();
});

function toggleBssNavOnScroll() {
  const MIN_HEIGHT_FOR_SCROLL = 660;
  const $target = $('.m-bssNavigation');
  if (!$target.length) {
    console.warn('Warning: .m-bssNavigation element not found.');
    return;
  }
  const $header = $('.m-site-header');

  function updateNavState() {
    if (window.innerWidth < 768) return;
    const canseeHeader = $header.offset().top + $header.outerHeight() > window.scrollY;
    // ヘッダーが画面に見えている場合
    if (canseeHeader && $target.hasClass('is-scroll')) {
      $target.removeClass('is-scroll');
      return;
    }
    if (canseeHeader) return;
    $target.addClass('is-scroll');
  }

  const debounce = (func, wait) => {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  const debouncedUpdateNavState = debounce(updateNavState, 100);

  window.addEventListener('resize', debouncedUpdateNavState);
  window.addEventListener('scroll', debouncedUpdateNavState);

  // ページ読み込み時にも1回実行
  updateNavState();
}

function scrollChangeBg() {
  const $bgTargets = $('.js-scrollChange-bg');
  const sections = document.querySelectorAll('.js-scrollChange-section');
  if ($bgTargets.length === 0 || sections.length === 0) return;

  const $bgTarget1 = $('.img02');
  const $bgTarget2 = $('.img03');
  const $bgTarget3 = $('.img04');
  const $bgTarget4 = $('.img05');
  const $bgTarget5 = $('.img06');
  const $navBg = $('#js-scrollChange-navBg');

  let sectionsPositions = [];

  function getSectionPositions() {
    return Array.from(sections).map(section => ({
      top: section.getBoundingClientRect().top + window.scrollY,
      bottom: section.getBoundingClientRect().bottom + window.scrollY
    }));
  }

  function updateBg() {
    const [sec1, sec2, sec3, sec4, sec5] = sectionsPositions;
    // console.log('sectionsPositions :>> ', sectionsPositions);
    const scrollPos = (window.scrollY || document.documentElement.scrollTop) + window.innerHeight / 2;
    // console.log('scrollPos :>> ', scrollPos);

    $bgTarget1.toggleClass('is-show', scrollPos >= sec1.top);
    $bgTarget2.toggleClass('is-show', scrollPos >= sec2.top);
    $bgTarget3.toggleClass('is-show', scrollPos >= sec3.top);
    $bgTarget4.toggleClass('is-show', scrollPos >= sec4.top);
    $bgTarget5.toggleClass('is-show', scrollPos >= sec5.top);
    $navBg.toggleClass('is-hide', scrollPos >= sec5.top);
  }

  function onResize() {
    sectionsPositions = getSectionPositions();
    updateBg();
  }

  window.addEventListener('scroll', updateBg);
  window.addEventListener('resize', onResize);

  onResize();
}

function bssNav() {
  // @TODO: window.matchMedia を使うと良さそう
  // https://qiita.com/fg-ohkawa/items/0f648adbe348402e3802
  const $bssNavContent = $('#js-bssNav-content');
  const $anchors = $('#js-bssNav-content').find('a[href^="#"]');
  const $bssNavOpenBtn = $('#js-bssNav-openBtn');
  const $bssNavCloseBtn = $('#js-bssNav-closeBtn');
  const $body = $('body');
  const options = {
    root: null,
    rootMargin: "0px 0px",
    threshold: 0
  };

  if ($bssNavContent.length === 0 || $anchors.length === 0) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        $bssNavOpenBtn.addClass('is-show');
      } else {
        $bssNavOpenBtn.removeClass('is-show');
      }
    });
  }, options);

  const hook = document.getElementById('js-bssNav-hook');
  if (hook) {
    observer.observe(hook);
  } else {
    observer.observe(document.querySelector('.m-site-header'));
  }

  $bssNavOpenBtn.on('click', function() {
    openMenu();
  });
  $bssNavCloseBtn.on('click', function() {
    closeMenu();
  });
  $anchors.on('click', function() {
    closeMenu();
  });
  $(window).on('resize', function() {
    if ($(window).width() >= 768) {
      closeMenu();
    }
  });

  function openMenu() {
    $bssNavContent.addClass('is-open');
    $body.addClass('is-lock');
  }

  function closeMenu() {
    $bssNavContent.removeClass('is-open');
    $body.removeClass('is-lock');
  }
}

function setJsHover() {
	$('img.jshover,input.jshover').each(function() {
		var splitSlash = $(this).attr('src').split('/');
		var splitDot = splitSlash[splitSlash.length - 1].split('.');
		var newSrc = $(this).attr('src');
		$(this).hover(
			function() {
				splitDot[splitDot.length - 2] += '_on';
				splitSlash[splitSlash.length - 1] = splitDot.join('.');
				newSrc = splitSlash.join('/');
				$(this).attr('src', newSrc);
			},
			function() {
				splitDot[splitDot.length - 2] = splitDot[splitDot.length - 2].replace('_on', '');
				splitSlash[splitSlash.length - 1] = splitDot.join('.');
				newSrc = splitSlash.join('/');
				$(this).attr('src', newSrc);
			}
		);
	});
}

function innerLinkMove () {
  $(document).on('click', 'a[href^="#"]', function(e) {
    var target = $(this).attr('href');
    if (target.startsWith('#js-popup')) {
      e.preventDefault();
      return false;
    }
    // 対象が存在しない場合は何もしない
    if (target === '#backToTop') {
      $('html,body').animate({ scrollTop: 0 }, 'fast');
    } else if ($(target).length) {
      var p = $(target).offset().top;
      $('html,body').animate({ scrollTop: p }, 'fast');
    }
    e.preventDefault();
    return false;
  });
}

function execInView() {
  inView.offset(100);

  inView('.js-inView, .js-opacityInView, .js-largeInVeiw, .js-smallInVeiw, .js-messageInView, .js-rotationInVeiw, .js-textLeftInVeiw, .js-shotInView, .js-kumamotoInView').on('enter', element => {
    element.classList.add('is-inView');
  });

  inView('.js-inView-parent').on('enter', parentElement => {
    const childElements = parentElement.querySelectorAll('.js-inView-child');
    if (childElements.length === 0) return;
    Array.prototype.slice.call(childElements).forEach((elm, i) => {
      setTimeout(() => {
        elm.classList.add('is-inView');
      }, i * 150);
    })
  });
}

function qaForm() {
  const $form = $('#qaForm');
  const $presentCampaign = $form.find('.presentCampaign');
  const $presentCampaignInputs = $presentCampaign.find('input, select');
  const $presentEntryRadio = $form.find('input[name="プレゼントキャンペーン参加"]:radio');
  $presentEntryRadio.on('change', function() {
    if (this.value == 'はい') {
      $presentCampaign.fadeIn('fast');
      $presentCampaignInputs.prop('disabled', false);
    } else {
      $('.presentCampaign').fadeOut('fast');
      $presentCampaignInputs.prop('disabled', true);
    }
  })
}

/**
 * アコーディオンのセットアップ
 */
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-accordion");
  const RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-accordion-summary");
    const content = element.querySelector(".js-accordion-content");

    summary.addEventListener("click", (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
      if (element.dataset.animStatus === RUNNING_VALUE) {
        return;
      }

      // detailsのopen属性を判定
      if (element.open) {
        // アコーディオンを閉じるときの処理
        // アイコン操作用クラスを切り替える(クラスを取り除く)
        element.classList.toggle(IS_OPENED_CLASS);

        // アニメーションを実行
        const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を付与
        element.dataset.animStatus = RUNNING_VALUE;

        // アニメーションの完了後に
        closingAnim.onfinish = () => {
          // open属性を取り除く
          element.removeAttribute("open");
          // アニメーション実行中用の値を取り除く
          element.dataset.animStatus = "";
        };
      } else {
        // アコーディオンを開くときの処理
        // open属性を付与
        element.setAttribute("open", "true");

        // アイコン操作用クラスを切り替える(クラスを付与)
        element.classList.toggle(IS_OPENED_CLASS);

        // アニメーションを実行
        const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を入れる
        element.dataset.animStatus = RUNNING_VALUE;

        // アニメーション完了後にアニメーション実行中用の値を取り除く
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
}

/**
 * アニメーションの時間とイージング
 */
const animTiming = {
  duration: 200,
  easing: "ease-out"
};

/**
 * アコーディオンを閉じるときのキーフレームを作成します。
 * @param content {HTMLElement}
 */
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
    opacity: 1,
  }, {
    height: 0,
    opacity: 0,
  }
];

/**
 * アコーディオンを開くときのキーフレームを作成します。
 * @param content {HTMLElement}
 */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  }, {
    height: content.offsetHeight + 'px',
    opacity: 1,
  }
];
